export enum DateKey {
  CreatedAt = "created_at",
  UpdatedAt = "updated_at",
}
